import { useMutation } from 'react-query'
import swal from 'sweetalert'
import { privateAPI } from '../config/constants'
import { decrypt } from '../functions/globalFunctions'
import * as feedbackTypes from '../redux/types/feedbackTypes'

const getAllFeedbacksQuestion = async () => {
  try {
    const res = await privateAPI.post('/feedback/get-feedback-question')
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

const getWordCloudData = async (payload) => {
  try {
    const res = await privateAPI.post('/feedback/get-word-cloud-data', { data: payload })

    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}
const getNpsOvertimeData = async (payload) => {
  try {
    const res = await privateAPI.post('feedback/get-nps-chart-data', { data: payload })

    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}
const getAllFeedbacks = async (payload) => {
  try {
    const res = await privateAPI.post('/feedback/get-all-feedback', { data: payload })
    // console.log(decrypt(res.data))
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}
const getAllFeedbackMobile = async (payload) => {
  try {
    const res = await privateAPI.post('/feedback/get-feedback-by-mobile', { data: payload })
    console.log(decrypt(res.data))
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}
const createFeedback = async (payload) => {
  try {
    const res = await privateAPI.post('/feedback/create-feedback', { data: payload })
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}
export const createFeedbackQuestion = async (payload) => {
  try {
    const res = await privateAPI.post('/feedback/create-feedback-question', { data: payload })
    return res.data
  } catch (error) {
    console.log({ error })
    swal('', error.message || 'Server Error', 'error')
  }
}

export const getNPSsegmented = async () => {
  try {
    const res = await privateAPI.post('/feedback/get-segmented-feedbacks')
    console.log('res', decrypt(res.data))
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}
/* =========================== USE MUTATION FUNC ================================== */
export const useGetAllFeedbackQuestion = () => {
  return useMutation(getAllFeedbacksQuestion)
}
export const useGetSegmentedFeedback = () => {
  return useMutation(getNPSsegmented)
}
export const useGetWordCloudData = (dispatch) => {
  return useMutation(getWordCloudData, {
    onSuccess: (payloadData) => {
      dispatch({
        type: feedbackTypes.GET_WORD_CHART,

        payload: payloadData,
      })
    },
  })
}

export const useGetAllFeedbacks = (dispatch) => {
  return useMutation(getAllFeedbacks, {
    onSuccess: (payloadData) => {
      dispatch({
        type: feedbackTypes.GET_ALL_FEEDBACKS,

        payload: payloadData,
      })
    },
  })
}
export const useGetMobileNoFeedbacks = (dispatch) => {
  return useMutation(getAllFeedbackMobile, {
    onSuccess: (payloadData) => {
      dispatch({
        type: feedbackTypes.GET_ALL_FEEDBACKS,

        payload: payloadData,
      })
    },
  })
}
export const useGetNPSScore = (dispatch) => {
  return useMutation(getNpsOvertimeData, {
    onSuccess: (payloadData) => {
      dispatch({
        type: feedbackTypes.GET_NPS_SCORE,

        payload: payloadData,
      })
    },
  })
}

export const useCreateFeedback = (dispatch) => {
  return useMutation(createFeedback, {
    onSuccess: (payloadData) => {
      dispatch({
        type: feedbackTypes.CREATE_FEEDBACK,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}
export const useCreateFeedbackQuestion = (dispatch) => {
  return useMutation(createFeedbackQuestion, {
    onSuccess: (payloadData) => {
      dispatch({
        type: feedbackTypes.CREATE_FEEDBACK,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}
